import React, { Fragment, useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { Grid, List, ListItem, ListItemText, Divider, Typography } from '@material-ui/core';
import { Page, AppBar, ScreenLoader, EmptyState } from 'components';
import { anketsStore, beneficiariesStore } from 'stores';
import { ru } from 'locale';
import { NoData as NoDataBg } from 'resources/images';
import useStyles from './BeneficiariesScreen.styles';

const BeneficiariesScreen = observer(() => {
  const history = useHistory();
  const classes = useStyles();
  const { fetchState, beneficiaries } = beneficiariesStore;
  const hasBeneficiaries = beneficiaries.length !== 0;

  useEffect(
    () =>
      autorun(() => {
        beneficiariesStore.getBeneficiaries(anketsStore.anketId);
      }),
    [],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderSecondaryText = beneficiary => {
    const share = beneficiary.isAccurate ? `~${beneficiary.share}` : beneficiary.share;

    return (
      <>
        <Typography component="span" variant="body2" color="textPrimary">
          {`${share}%`}
        </Typography>
        <span className={classes.inn}>{`${ru.inn} ${beneficiary.inn}`}</span>
      </>
    );
  };

  const renderBeneficiaries = () => {
    if (!hasBeneficiaries) {
      return (
        <EmptyState
          image={{ source: NoDataBg, alt: ru.listOfBeneficiaries }}
          title={ru.emptyList(ru.listOfBeneficiaries)}
        />
      );
    }

    return (
      <List component="nav" aria-label={ru.beneficiaries}>
        {beneficiaries.map(beneficiary => (
          <Fragment key={beneficiary.inn}>
            <ListItem>
              <ListItemText
                primary={beneficiary.fio}
                secondary={renderSecondaryText(beneficiary)}
              />
            </ListItem>
            <Divider />
          </Fragment>
        ))}
      </List>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <AppBar title={ru.beneficiaries} onNavButtonClick={handleBackClick} />
        {fetchState === 'pending' && <ScreenLoader />}

        <Grid
          container
          item
          direction="column"
          justify={hasBeneficiaries ? 'flex-start' : 'center'}
          className={cn({
            [classes.content]: !hasBeneficiaries,
          })}
        >
          {fetchState === 'fulfilled' && renderBeneficiaries()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default BeneficiariesScreen;
